import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { useT, Namespace } from "@racoon/i18n";

export default function ErrorPage() {
  const t = useT();
  const err = useRouteError();
  if (isRouteErrorResponse(err)) {
    return (
      <div className="p-6">
        <h1 className="text-xl font-semibold">{t(Namespace.Errors, "errorWithStatus", { status: err.status })}</h1>
        <p>{err.statusText}</p>
      </div>
    );
  }
  return <div className="p-6">{t(Namespace.Errors, "somethingWentWrong")}</div>;
}
